// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"4aa4d2421acbc9dfe289","293":"b2fbd11e27d19cbd1141"}[chunkId] + ".js";
};